<template>
  <div id="custom_request_option_info" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLiveLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <loading-modal :is-loading="isLoading"></loading-modal>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content closefriend-modal" style="background-color: #1a1a1a; border: 1px solid rgba(255,255,255,0.1); border-radius: 16px;">

        <div class="modal-header border-0 align-items-center pb-2">
          <button type="button" class="close text-white" @click="back()" style="position: absolute; left: 20px; opacity: 0.8; text-shadow: none;">
            <i class="fa fa-arrow-left font-size-16" aria-hidden="true"></i>
          </button>
          <h4 class="modal-title mx-auto font-size-16 font-weight-bold text-white">Submit Custom Request</h4>
          <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" style="position: absolute; right: 20px; opacity: 0.8; text-shadow: none;">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        
        <div class="modal-body text-center pt-0 px-4 pb-4">
          <model-global-message
            :global-errors="globalErrors"
            :message="message"
            @clearMessages="clearMessages()"/>

          <div class="mb-4">
            <div class="d-flex justify-content-between align-items-center px-3 py-3" style="background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 12px;">
              <span class="text-white font-size-14 text-left" style="overflow-wrap: anywhere; max-width: 70%;">{{customRequestOption.title}}</span>
              <span class="stella-card-price">${{customRequestOption.price}}</span>
            </div>
          </div>

          <div class="text-left mt-3">
            <label class="font-size-14 font-weight-bold text-white mb-3" style="line-height: 1.5; opacity: 0.9;">
              Please add any additional info like names or any other information <span style="color: #ff6ec7;">{{influencerName}}</span> will require to complete your request:
            </label>
            <required-field v-if="isRequired('requestDescription')"/>
            <p v-if="warningMessage" class="warning-message">{{ warningMessage }}</p>
            <textarea
              class="w-100 mb-4 text-white p-3 font-size-14" rows="4"
              style="background: rgba(255,255,255,0.05) !important; border: 1px solid rgba(255,255,255,0.1); border-radius: 12px; resize: none; outline: none;"
              placeholder="Enter your request details here..."
              v-model="customRequest.requestDescription"></textarea>

            <button
              class="btn rounded-pill font-weight-bold px-4 py-2 font-size-14 text-dark w-100"
              style="background: linear-gradient(135deg, #ff6ec7, #f9a826); border: none;"
              @click="saveCustomRequest()">Submit Custom Request
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {customerCustomRequestMixin} from "@/mixin/customer-custom-request-mixin";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import {required} from "vuelidate/lib/validators";
import RequiredField from "@/components/module/shared/RequiredField";
import GlobalMessage from "@/components/module/shared/GlobalMessage";

export default {
  name: "ModelCustomerCustomRequestOptionInfo",
  mixins: [customerCustomRequestMixin],
  components: {RequiredField, GlobalMessage},
  data() {
    return {
      customRequestOption: {},
      influencerName: '',
      warningMessage: ''
    }
  },
  validations: {
    customRequest: {
      requestDescription: {required},
    }
  },
  methods: {
    show(customRequest, customerId) {
      this.clearMessages();
      this.customRequest = customRequest;
      this.customerId = customerId;
      this.customRequest.offerPrice = null;
      this.customRequest.requestDescription = null;
      this.loadData();
      $('#custom_request_option_info').modal();
      this.warningMessage = '';
    },
    hide() {
      $('#custom_request_option_info').modal('hide');
    },
    loadData() {
      let optionId = this.customRequest.options.id;
      let influencerId = this.customRequest.influencer.id;
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${influencerId}/custom-request-options/${optionId}`;
      this.getData(url, (customRequestOption) => {
        this.customRequestOption = customRequestOption;
        this.influencerName = customRequestOption.influencer.name;
      });

    },
    saveCustomRequest() {

      this.isSubmitted = true;
      this.$v.$touch();
      if (this.customRequest.requestDescription.length > 1000) {
        this.warningMessage = 'Your input exceeds the 1000-character limit.';
        return;
      } else {
        this.warningMessage = '';
      }

      if (this.$v.$invalid) {
        return;
      }

      this.customRequest.offerPrice = this.customRequestOption.price;
      let url = `${SERVICE_CONTENT}/api/v1/customers/${this.customerId}/custom-request/`;
      this.postData(url, this.customRequest, (customRequest) => {
        this.hide();
        this.$emit("savedCustomRequestOption", customRequest);
      });
    },
    back() {
      this.hide();
      this.$emit('back');
    }
  }
}
</script>

<style scoped>
.warning-message {
  color: #ff4b81;
  font-size: 0.9em;
  margin-top: 5px;
}

textarea:focus {
  border-color: rgba(255, 110, 199, 0.5) !important;
}
</style>
